<template>
  <div id="menu-monitoring" role="tabpanel" class="tab-pane show active" aria-labelledby="monitoring-tab">
    <div class="submenu-nav-header">
      <div class="my-1 d-lg-none"></div>
      <h4 class="mb-0">Monitoring</h4>
      <small class="mb-1"><i>Live Tracking & Monitoring of Vehicles and Units</i></small>
    </div>
    <ul class="nav nav-pills" id="submenu-monitoring" role="tablist">
      <li class="nav-item">
        <a id="sm-monitoring-tab" class="nav-link submenu-nav-pill active" data-toggle="tab"
           href="#sm-monitoring" role="tab" aria-controls="sm-monitoring"
           aria-selected="true">
          <fa-icon icon="map-marker" />&nbsp;&nbsp;Monitoring</a>
      </li>
    </ul>
    <div class="tab-content">
      <hr class="mt-2">
      <div id="sm-monitoring" role="tabpanel" class="tab-pane active">
        <div class="row">
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.liveTracking.routerTo"
                         @click.native="setMenuState()">
               <div class="submenu-nav-icon">
                 <fa-icon :icon="menu.liveTracking.icon" :class="menu.liveTracking.iconClass + ' fa-3x'"/>
               </div>
               <div class="submenu-nav-content">
                 <p class="submenu-nav-item-title">{{ menu.liveTracking.title }}</p>
                 <p class="submenu-nav-item-details">{{ menu.liveTracking.details }}</p>
               </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.liveSensors.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.liveSensors.icon" :class="menu.liveSensors.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.liveSensors.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.liveSensors.details }}</p>
              </div>
            </router-link>
          </div>
          <div class="col-md-6 col-xl-3">
            <router-link tag="div"
                         class="submenu-nav-item"
                         active-class="active"
                         :to="menu.liveEvents.routerTo"
                         @click.native="setMenuState()">
              <div class="submenu-nav-icon">
                <fa-icon :icon="menu.liveEvents.icon" :class="menu.liveEvents.iconClass + ' fa-3x'"/>
              </div>
              <div class="submenu-nav-content">
                <p class="submenu-nav-item-title">{{ menu.liveEvents.title }}</p>
                <p class="submenu-nav-item-details">{{ menu.liveEvents.details }}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuItems from '@/common/menu'

import {
  NAV_GET_MENU_OPEN,
  NAV_SET_MENU_OPEN
} from '@/store/navigation/nav.types'

export default {
  data () {
    return {
      menu: menuItems
    }
  },

  methods: {
    setMenuState () {
      this.$store.commit(NAV_SET_MENU_OPEN, !this.getMenuState())
    },

    getMenuState () {
      return this.$store.getters[NAV_GET_MENU_OPEN]
    }
  },

  components: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/navigation/NavMenuMonitoring.vue